import { ComponentConfig } from "@measured/puck";
import { Greetings } from "./Greetings";

export type GreetingsProps = {
    showUsername: "true" | "false";
    showCompany: "true" | "false";
};
export const GreetingsConfig: ComponentConfig<GreetingsProps> = {
    fields: {
        showUsername: {
            type: "select",
            label: "Show Username",
            options: [
                { label: "Yes", value: "true" },
                { label: "No", value: "false" },
            ],
        },
        showCompany: {
            type: "select",
            label: "Show Company Name",
            options: [
                { label: "Yes", value: "true" },
                { label: "No", value: "false" },
            ],
        },
    },
    defaultProps: {
        showUsername: "true",
        showCompany: "true",
    },
    render: (props) => {
        return <Greetings {...props} />;
    },
};

export default GreetingsConfig;
